/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCircleSquare: {
  name: 'circle-square';
  data: string;
} = {
  name: 'circle-square',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm4-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2Zm6 10a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-6Zm0 2h6v6h-6v-6Z" fill="currentColor"/></svg>`,
};
